import {Component, Input, OnInit} from '@angular/core';
import {faFilePdf, faDownload} from '@fortawesome/free-solid-svg-icons';
import {WorkflowInstanceModel} from "../../../../models/workflow/workflow-instance.model";
import {WorkflowStepFinishedModel} from "../../../../models/workflow-step/workflow-step-finished.model";
import {Globals} from "../../../../global/globals";
import {WorkflowInstanceService} from "../../../../services/workflow-instance.service";
import {WorkflowDetailClientService} from "../../../dialog/workflow-detail-dialog/workflow-detail-client.service";
import {WorkflowStep} from "../../../../enums/WorkflowStep";
import {WorkflowInstanceStepService} from "../../../../services/workflow-instance-step.service";
import {FileService} from "../../../../services/file.service";

@Component({
  selector: 'app-finished',
  templateUrl: './finished.component.html',
  styleUrls: ['./finished.component.scss']
})
export class FinishedComponent implements OnInit{

  @Input() workFlowStep: WorkflowStepFinishedModel;

  faFilePdf = faFilePdf;
  faDownload = faDownload;
  usedInLibrary: WorkflowInstanceModel;
  expandedSteps: Set<number> = new Set();

  constructor(public globals: Globals,
              private workflowInstanceService: WorkflowInstanceService,
              private workflowInstanceStepService: WorkflowInstanceStepService,
              private fileService: FileService,
              public workflowDetailClientService: WorkflowDetailClientService) {
  }

  ngOnInit(): void {
    this.fetchUsedInLibrary();
  }

  private fetchUsedInLibrary(): void {
    this.workflowInstanceService.getUsedInLibrary(this.workFlowStep.workflowInstance.id)
      .subscribe(resp => this.usedInLibrary = resp);
  }

  navigateToLibrary(): void {
    if (this.usedInLibrary) {
      this.workflowDetailClientService.jumpToWorkflowInstance(this.usedInLibrary);
    }
  }

  get uniqueLatestSteps() {
    const steps = this.workflowDetailClientService.workflowInstance?.steps || [];
    const seen = new Set<any>();
    const result: any[] = [];

    const allowedSteps = this.workflowDetailClientService.workflowInstance?.isLibrary() ?
      WorkflowStep.getAllForDashboardInLibrary().flat() :
      WorkflowStep.getAllForDashboardInWorkflow96And384().flat();

    // Iterate from the end to keep the newest occurrence for each step type
    for (let i = steps.length - 1; i >= 0; i--) {
      const s = steps[i];
      const key = s.step;
      if (!seen.has(key) && allowedSteps.includes(key)) {
        seen.add(key);
        result.push(s);
      }
    }

    // Reverse to preserve the original chronological order while keeping newest per type
    return result.reverse();
  }

  hasNonEmptyComment(comment: string | null | undefined): boolean {
    const c = comment != null ? comment.trim() : '';
    return c.length > 0;
  }

  commentStripped(comment: string, maxChars: number): string {
    return comment?.length > maxChars ? comment.substring(0, maxChars) + '...' : comment;
  }

  isExpanded(stepId: number): boolean {
    return this.expandedSteps.has(stepId);
  }

  toggleExpanded(stepId: number): void {
    if (this.isExpanded(stepId)) {
      this.expandedSteps.delete(stepId);
    } else {
      this.expandedSteps.add(stepId);
    }
  }

  downloadFullWorkflowPdf(): void {
    const workflow = this.workflowDetailClientService.workflowInstance;
    const prefix = workflow.isLibrary() ? 'Library' : 'Workflow';
    const fileName = `${prefix}_${workflow.workflowNumber}.pdf`;
    this.workflowInstanceStepService.downloadFullWorkflowPdf(workflow.id, fileName);
  }

  downloadStoredPdf(): void {
    if (this.workFlowStep.file) {
      this.fileService.downloadFile(this.workFlowStep.file.id, this.workFlowStep.file.name);
    }
  }

}
